import { render } from "./FiltrosFacturasElectronicas.vue?vue&type=template&id=8bf67694&scoped=true"
import script from "./FiltrosFacturasElectronicas.vue?vue&type=script&lang=js"
export * from "./FiltrosFacturasElectronicas.vue?vue&type=script&lang=js"

import "./FiltrosFacturasElectronicas.vue?vue&type=style&index=0&id=8bf67694&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_restaurante\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bf67694"]])

export default __exports__